import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import { Button, Flex, Typography } from 'antd'
import React, { useEffect, useRef, useState } from 'react'

const { Text } = Typography

const WorkIdeaCard = ({
  item,
  mode,
  onEditClick,
  onDelete,
  onSuggestToTeam,
  formatDate,
  colorCode,
  emoji,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const buttonRef = useRef(null)

  // 외부 클릭 시 메뉴 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(e.target) &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false)
      }
    }

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMenuOpen])

  const handleEdit = () => {
    onEditClick(item)
    setIsMenuOpen(false)
  }

  const handleDelete = () => {
    onDelete(item.id)
    setIsMenuOpen(false)
  }

  return (
    <div className="work-idea-card" style={{ backgroundColor: colorCode }}>
      {/* 헤더: 작성자/날짜 + 메뉴 */}
      <div className="card-header">
        <Text className="writer-info">
          {item.writerName || '사용자'}
          <span className="divider">|</span>
          <span className="date">{formatDate(item.writtenAt)}</span>
        </Text>
        <div style={{ position: 'relative' }}>
          <Button
            ref={buttonRef}
            type="text"
            icon={<MoreOutlined />}
            className="menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          />
          {isMenuOpen && (
            <div ref={menuRef} className="custom-dropdown-menu">
              <button
                type="button"
                className="custom-menu-item"
                onClick={handleEdit}
              >
                <EditOutlined />
                <span>수정</span>
              </button>
              <button
                type="button"
                className="custom-menu-item"
                onClick={handleDelete}
              >
                <DeleteOutlined />
                <span>삭제</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 제목 */}
      <Flex align="center" style={{ marginBottom: '12px' }} gap={6}>
        <Text style={{ fontSize: '24px', aspectRatio: '1/1' }}>{emoji}</Text>
        <Text strong className="card-title">
          {item.title || '제목 없음'}
        </Text>
      </Flex>

      {/* 설명 */}
      <Text className="card-memo">{item.memo || '메모 없음'}</Text>

      {/* 팀에게 아이디어 제안하기 버튼 (개인 모드일 때만) */}
      {mode === 'personal' && (
        <Button
          block
          className="suggest-button"
          onClick={() => onSuggestToTeam(item)}
        >
          팀에게 아이디어 제안하기
        </Button>
      )}
    </div>
  )
}

export default WorkIdeaCard
